/* ---------------------------------------------------------
* This file defines all production constants
------------------------------------------------------------ */

export const API_BASE_URL = 'https://experienciasback.aeromexicorewards.com/api/v1/experiences/';
export const POSTAL_CODE_URL = 'https://apicp.aeromexicorewards.com/api/v1/postal_code/show';
export const NEWSLETTER_SUBMIT_URL = 'https://member.aeromexicorewards.com/api/v1/preference/subscribe';
export const OUTSESION = 'https://member.aeromexicorewards.com/salir';
export const LOGIN_URL = 'https://member.aeromexicorewards.com/login/auth';
export const DEFAULT_URL_EXP = 'https://experiencias.aeromexicorewards.com';
export const RECOVERY_ACCOUNT_LINK = 'https://member.aeromexicorewards.com/individual/recuperacuenta';
export const RECOVERY_NIP_LINK = 'https://member.aeromexicorewards.com/recuperar-nip';
export const REGISTER_LINK = 'https://member.aeromexicorewards.com/registro';
export const CP_LINK = 'https://www.aeromexicorewards.com/mx/bienvenido/';
export const REDIRECT_LOGIN_LINK = 'https://member.aeromexicorewards.com/login?url=https%3A%2F%2Fexperiencias.aeromexicorewards.com';
export const SANTANDER_LINK = 'https://santander.aeromexicorewards.com/';
export const AMEX_LINK = 'https://americanexpressaeromexico.aeromexicorewards.com/';
export const ACCUMULATE_POINTS_LINK = 'https://www.aeromexicorewards.com/mx/acumula-puntos-premier';

/* Variables para QA:
 export const API_BASE_URL = 'https://experienciasbackqa.clubpremier.info/api/v1/experiences/';
 export const POSTAL_CODE_URL = 'https://apicp.aeromexicorewards.com/api/v1/postal_code/show';
 export const NEWSLETTER_SUBMIT_URL = 'https://member.clubpremier.info/api/v1/preference/subscribe';
 export const OUTSESION = 'https://member.clubpremier.info/salir';
 export const LOGIN_URL = 'https://member.clubpremier.info/login/auth';
 export const DEFAULT_URL_EXP = 'https://experienciasqa.clubpremier.info';
 export const RECOVERY_ACCOUNT_LINK = 'https://member.clubpremier.info/individual/recuperacuenta';
 export const RECOVERY_NIP_LINK = 'https://member.clubpremier.info/recuperar-nip';
 export const REGISTER_LINK = 'https://member.clubpremier.info/registro';
 export const CP_LINK = 'https://www.clubpremier.info/mx/bienvenido/';
 export const REDIRECT_LOGIN_LINK = 'https://member.clubpremier.info/login?url=https%3A%2F%2Fexperienciasqa.clubpremier.info';
 export const SANTANDER_LINK = 'https://santander.aeromexicorewards.com/';
 export const AMEX_LINK = 'https://americanexpressaeromexico.aeromexicorewards.com/';
 export const ACCUMULATE_POINTS_LINK = 'https://www.clubpremier.info/mx/acumula-puntos-premier';
 */
